import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router';
import MagicButton from 'components/MagicButton/MagicButton';
import { AssetUrls } from 'config/assets';
import './LoginPromptModal.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  collectionOwnerUsername: string;
}

const LoginPromptModal: React.FC<Props> = ({ isOpen, onClose, collectionOwnerUsername }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSignUp = () => {
    navigate('/welcome');
    onClose();
  };

  const handleLogIn = () => {
    navigate('/welcome');
    onClose();
  };

  const modalContent = (
    <div className="login-prompt-overlay" onClick={onClose}>
      <div className="login-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-prompt-close-button" onClick={onClose}>
          <img
            src={AssetUrls.icons.dropdowns.close}
            alt="Close"
            style={{ width: 16, height: 16 }}
          />
        </button>

        <div className="login-prompt-content">
          <div className="login-prompt-icon">🎴</div>

          <h2 className="login-prompt-title">Join TradeMagic to Start Trading</h2>

          <p className="login-prompt-body">
            Create an account to trade cards with <strong>{collectionOwnerUsername}</strong> and thousands of other players.
          </p>

          <div className="login-prompt-actions">
            <MagicButton
              label="Sign Up for Free"
              color="purple"
              onPress={handleSignUp}
              fullWidth
            />

            <div className="login-prompt-secondary">
              Already have an account?{' '}
              <button className="login-prompt-link" onClick={handleLogIn}>
                Log In
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LoginPromptModal;
